// =====================================================================
//  Arrastrar y soltar (estilo celular) para los íconos de apps.
//  - Usa Pointer Events (sirve para mouse Y táctil en tablet/celular).
//  - Se activa con "long-press" (~300 ms) para no estorbar el tap normal
//    ni el scroll de la página.
//  - Crea un "fantasma" que sigue el dedo y, al soltar, avisa por dockBus.
//
//  enableDockDrag(el, funcId, origin)
//     origin: "home" (grilla del dashboard) | "dock" (footer)
// =====================================================================

import { dockBus } from "./dockBus.js";

export function enableDockDrag(el, funcId, origin) {
    if (!el) return;

    var pressTimer = null;
    var dragging = false;
    var ghost = null;
    var startX = 0, startY = 0;
    var moved = false;
    var ptrType = "mouse";

    function point(e) {
        if (e.touches && e.touches[0]) return { x: e.touches[0].clientX, y: e.touches[0].clientY };
        return { x: e.clientX, y: e.clientY };
    }

    function onDown(e) {
        // Solo botón principal del mouse
        if (e.button !== undefined && e.button !== 0) return;
        var p = point(e);
        ptrType = e.pointerType || "mouse";
        startX = p.x; startY = p.y; moved = false; dragging = false;

        // En táctil: long-press para no estorbar el scroll.
        // Con mouse: NO hay long-press; arrastra apenas se mueve (ver onMove).
        if (ptrType !== "mouse") {
            pressTimer = setTimeout(function () { startDrag(p); }, 300);
        }

        document.addEventListener("pointermove", onMove, { passive: false });
        document.addEventListener("pointerup", onUp);
        document.addEventListener("pointercancel", onUp);
    }

    function startDrag(p) {
        dragging = true;
        if (navigator.vibrate) { try { navigator.vibrate(20); } catch (e) {} }

        ghost = el.cloneNode(true);
        ghost.style.position = "fixed";
        ghost.style.left = (p.x - 33) + "px";
        ghost.style.top = (p.y - 33) + "px";
        ghost.style.width = "66px";
        ghost.style.margin = "0";
        ghost.style.opacity = "0.9";
        ghost.style.pointerEvents = "none";
        ghost.style.zIndex = "99999";
        ghost.style.transform = "scale(1.12)";
        ghost.style.transition = "none";
        document.body.appendChild(ghost);

        dockBus.$emit("drag:start", { funcId: funcId, origin: origin });
    }

    function onMove(e) {
        var p = point(e);
        if (Math.abs(p.x - startX) > 8 || Math.abs(p.y - startY) > 8) moved = true;

        if (!dragging) {
            if (moved) {
                clearTimeout(pressTimer);
                if (ptrType === "mouse") {
                    // Con mouse: arrastrar apenas se mueve (no hay scroll por arrastre)
                    startDrag({ x: p.x, y: p.y });
                } else {
                    // Táctil: si se movió antes del long-press, es scroll: cancelar
                    cleanup();
                }
            }
            return;
        }
        // Ya estamos arrastrando: bloquear el scroll y mover el fantasma
        if (e.cancelable) e.preventDefault();
        if (ghost) { ghost.style.left = (p.x - 33) + "px"; ghost.style.top = (p.y - 33) + "px"; }
        dockBus.$emit("drag:move", { x: p.x, y: p.y });
    }

    function onUp(e) {
        clearTimeout(pressTimer);
        if (dragging) {
            var p = point(e);
            dockBus.$emit("drag:drop", { funcId: funcId, origin: origin, x: p.x, y: p.y });
            if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
            ghost = null;
            // Evitar que el "soltar" dispare el click/navegación del <a>
            suppressNextClick();
        }
        cleanup();
    }

    function suppressNextClick() {
        var sup = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            el.removeEventListener("click", sup, true);
        };
        el.addEventListener("click", sup, true);
        setTimeout(function () { el.removeEventListener("click", sup, true); }, 450);
    }

    function cleanup() {
        dragging = false;
        document.removeEventListener("pointermove", onMove);
        document.removeEventListener("pointerup", onUp);
        document.removeEventListener("pointercancel", onUp);
        dockBus.$emit("drag:end");
    }

    function onDragStart(e) { e.preventDefault(); } // matar el drag nativo de <a>/<img>

    el.addEventListener("pointerdown", onDown);
    el.addEventListener("dragstart", onDragStart);

    // Permite desconectar los listeners si el elemento se reusa
    el._dockDragCleanup = function () {
        el.removeEventListener("pointerdown", onDown);
        el.removeEventListener("dragstart", onDragStart);
    };
}
